module.exports = __webpack_public_path__ + "img/nav-right.9f01891f.svg";